import { get, omitBy } from "lodash"
import PropTypes from "prop-types"
import React from "react"
import { Link } from "react-router-dom"
import {
	Breadcrumb,
	Container,
	Divider,
	Header,
	Loader,
	Message,
	Pagination,
	Segment,
	Sidebar
} from "semantic-ui-react"
import { compose, lifecycle, withHandlers, withState } from "recompose"
import { LogContext, LogsTable, SearchForm } from "./components"
import { LogsApiService } from "../../api"

const Logs = ({
	activePage,
	isLoading,
	logs,
	onPageChange,
	onSearch,
	onSelectLog,
	selectedLog,
	totalPages
}) => (
	<Container>
		<Breadcrumb>
			<Breadcrumb.Section as={Link} to="/">
				Strona główna
			</Breadcrumb.Section>
			<Breadcrumb.Divider icon="right angle" />
			<Breadcrumb.Section active>Logi</Breadcrumb.Section>
		</Breadcrumb>
		<SearchForm onSubmit={onSearch} />
		{isLoading ? (
			<Loader active={true} content="Ładowanie logów..." inline="centered" />
		) : logs.length > 0 ? (
			<LogsTable logs={logs} onSelect={onSelectLog} selected={selectedLog} />
		) : (
			<Message
				content="Nie znaleziono logów pasujących do wyszukiwanych parametrów."
				header="Brak wyników"
				icon="frown"
			/>
		)}
		{totalPages > 1 && (
			<Pagination
				activePage={activePage}
				onPageChange={onPageChange}
				totalPages={totalPages}
			/>
		)}
		<Sidebar
			animation="overlay"
			as={Segment}
			direction="right"
			visible={selectedLog !== null}
			width="very wide">
			<Header as="h3">Kontekst</Header>
			<Divider />
			<LogContext context={get(selectedLog, "context")} />
		</Sidebar>
	</Container>
)

Logs.propTypes = {
	activePage: PropTypes.number,
	isLoading: PropTypes.bool,
	logs: PropTypes.array,
	onPageChange: PropTypes.func,
	onSearch: PropTypes.func.isRequired,
	onSelectLog: PropTypes.func.isRequired,
	selectedLog: PropTypes.object,
	totalPages: PropTypes.number
}

Logs.defaultProps = {
	activePage: 1,
	logs: [],
	onPageChange: () => {},
	totalPages: 1
}

const enhance = compose(
	withState("activePage", "setActivePage", 1),
	withState("isLoading", "setLoading", false),
	withState("logs", "setLogs", []),
	withState("searchParams", "setSearchParams", {}),
	withState("selectedLog", "setSelectedLog", null),
	withState("totalPages", "setTotalPages", 1),
	withHandlers({
		onPageChange: ({ searchParams, setActivePage, setLoading, setLogs }) => async (
			e,
			{ activePage }
		) => {
			setActivePage(activePage)
			const params = {
				page: activePage,
				...searchParams
			}
			setLoading(true)
			try {
				const { logs } = await LogsApiService.getLogs(params)
				setLogs(logs)
			} finally {
				setLoading(false)
			}
		},
		onSearch: ({
			setActivePage,
			setLoading,
			setLogs,
			setSearchParams,
			setTotalPages
		}) => async searchParams => {
			const clearedSearchParams = omitBy(
				searchParams,
				param => param === null || param === undefined
			)
			setActivePage(1)
			setSearchParams(clearedSearchParams)
			const params = {
				page: 1,
				...clearedSearchParams
			}
			setLoading(true)
			try {
				const { limit, logs, totalCount } = await LogsApiService.getLogs(params)
				setLogs(logs)
				const totalPages = Math.ceil(totalCount / limit)
				setTotalPages(totalPages)
			} finally {
				setLoading(false)
			}
		},
		onSelectLog: ({ selectedLog, setSelectedLog }) => (event, log) => {
			const newSelectedLog = get(selectedLog, "logId") !== get(log, "logId") ? log : null
			setSelectedLog(newSelectedLog)
		}
	}),
	lifecycle({
		async componentDidMount() {
			const { setLoading, setLogs, setTotalPages } = this.props
			setLoading(true)
			try {
				const { limit, logs, totalCount } = await LogsApiService.getLogs()
				setLogs(logs)
				const totalPages = Math.ceil(totalCount / limit)
				setTotalPages(totalPages)
			} finally {
				setLoading(false)
			}
		}
	})
)

export { Logs, enhance }
export default enhance(Logs)



// WEBPACK FOOTER //
// ./src/containers/logs/Logs.js